module.exports = __webpack_public_path__ + "media/Components/fonts/boldRalewayitalic-5acd54532f4871fb1ca993e5b11503dc.ttf";